<script>
import Endpoints from '../../../../components/common/Endpoints';
import Common from '../../../../components/common/Common';
import Request from '../../../../components/common/Request';
import { mapActions } from 'vuex'

export default {
    init: async(payload) => {
        const el = document.body;
        el.removeAttribute("class");
        $('.modal').modal('hide');

    },
    methods:{
      filter: async function(){
        let responseTruckTrailersVanderleia = (await Request.do(this, 'POST', Request.getDefaultHeader(this), {fileName: "Trucks",collectionName: "trucks",filters:{vehicleType: "TRUCKTRAILER_VANDERLEIA",status:"ACTIVE"}}, `${Endpoints.systemUsers.count}`)).data;
        let responseTruckTrailersConvencional = (await Request.do(this, 'POST', Request.getDefaultHeader(this), {fileName: "Trucks",collectionName: "trucks",filters:{vehicleType: "TRUCKTRAILER_CONVENCIONAL",status:"ACTIVE"}}, `${Endpoints.systemUsers.count}`)).data;
        let responseTruckTrailersDolly= (await Request.do(this, 'POST', Request.getDefaultHeader(this), {fileName: "Trucks",collectionName: "trucks",filters:{vehicleType: "TRUCKTRAILER_DOLLY",status:"ACTIVE"}}, `${Endpoints.systemUsers.count}`)).data;
        let responseTruckTrailersBitrem = (await Request.do(this, 'POST', Request.getDefaultHeader(this), {fileName: "Trucks",collectionName: "trucks",filters:{vehicleType: "TRUCKTRAILER_BITREM",status:"ACTIVE"}}, `${Endpoints.systemUsers.count}`)).data;
        let responseTruckTrailersRodotrem = (await Request.do(this, 'POST', Request.getDefaultHeader(this), {fileName: "Trucks",collectionName: "trucks",filters:{vehicleType: "TRUCKTRAILER_RODOTREM",status:"ACTIVE"}}, `${Endpoints.systemUsers.count}`)).data;

            this.total = responseTruckTrailersVanderleia.count+responseTruckTrailersConvencional.count+responseTruckTrailersDolly.count+responseTruckTrailersBitrem.count+responseTruckTrailersRodotrem.count;

          if (responseTruckTrailersVanderleia.status==200 && responseTruckTrailersConvencional.status==200 && responseTruckTrailersDolly.status==200 && responseTruckTrailersBitrem.status==200 && responseTruckTrailersRodotrem.status==200){
            this.chart.data.datasets[0].data = [responseTruckTrailersVanderleia.count,responseTruckTrailersConvencional.count,responseTruckTrailersDolly.count,responseTruckTrailersBitrem.count,responseTruckTrailersRodotrem.count];
            this.chart.update(); 
          }
      }
      
    }
}
</script>
